import { ActivityLogGridView } from '~/components/system/activity-log';
import { PageContainer } from '~/components/page-container';

export function ActivityLog() {
	return (
		<PageContainer>
			<ActivityLogGridView />
		</PageContainer>
	);
}
